export default __webpack_public_path__ + "static/media/template-disabled.6fe6c3f7.svg";